// Import
export const CLEAR_IMPORT_DATA = 'clearImportData';
export const SET_MANUSCRIPTS_SEARCH_TEXT = 'setManuscriptsSearchText';
export const SET_MANUSCRIPTS_SORT = 'setManuscriptsSort';
export const SET_GUID_IMPORT_TEXT = 'setGuidImportText';
export const REMOVE_IMPORT_ITEM = 'removeImportItem';
export const ADD_IMPORT_ITEMS = 'addImportItems';
export const UPDATE_IMPORT_ITEMS = 'updateImportItems';
export const UPDATE_AND_VALIDATE_IMPORT_ITEMS = 'updateAndValidateImportItems';
export const ADD_GUID_IMPORT_ITEMS = 'addGuidImportItems';
export const ADD_FILE_IMPORT_ITEMS = 'addFileImportItems';
export const ADD_IMPORT_ITEMS_TO_QUEUE = 'addImportItemsToQueue';
export const VALIDATE_IMPORT_ITEMS = 'validateImportItems';
export const GET_IMPORTED_MANUSCRIPTS = 'getImportedManuscripts';
export const UPDATE_FLEX_BOXES = 'updateFlexBoxes';
export const START_MANUSCRIPT_UPDATES = 'startManuscriptUpdates';
export const STOP_MANUSCRIPT_UPDATES = 'stopManuscriptUpdates';
export const SET_MANUSCRIPT_UPDATES_ENABLED = 'setManuscriptUpdatesEnabled';
export const SET_CONFIRM_NAVIGATE_DIALOG = 'setConfirmNavigateDialog';

// Manuscript
export const DELETE_MANUSCRIPT = 'deleteManuscript';
export const PATCH_MANUSCRIPT = 'patchManuscript';
export const GET_MANUSCRIPT = 'getManuscript';
export const GET_MANUSCRIPTS = 'getManuscripts';
